import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { recordInstanceQueryOptions } from "@/services/record";

/**
 * Thin Record instance layout — shared params / soft prefetch for drawer tabs.
 * Drawer chrome lives in the pathless `_drawer` layout.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId",
)({
	params: {
		parse: (params) => ({
			recordId: z.string().parse(params.recordId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(
			`/workspace/records/${params.recordId}`,
		);
		if (exactRoot) {
			const searchResult = z
				.object({ q: z.string().optional() })
				.safeParse(location.search);
			const q = searchResult.success ? searchResult.data.q : undefined;
			throw redirect({
				to: "/web/$orgId/jobs/$jobId/workspace/records/$recordId/details",
				params: {
					orgId: params.orgId,
					jobId: params.jobId,
					recordId: params.recordId,
				},
				search: { q },
			});
		}
	},
	loader: ({ context, params }) => {
		// Prefetch without blocking — drawer opens immediately with loading state.
		void context.queryClient.prefetchQuery(
			recordInstanceQueryOptions.detail(params.recordId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: RecordIdLayout,
});

function RecordIdLayout() {
	return <Outlet />;
}
